import { AreaChartOutlined } from "@ant-design/icons";
import React from "react";

import {
  Cards,
  FolderNotchOpen,
  Graph,
  Cube,
  AddressBook,
  ChartBarHorizontal,
  CloudArrowDown,
  Scroll,
  GearSix,
} from "@phosphor-icons/react";

const icons = {
  Down() {
    return (
      <svg width="17" height="9.032" viewBox="0 0 17 9.032">
        <g
          id="Group_446"
          data-name="Group 446"
          transform="translate(17) rotate(90)"
        >
          <g id="Group_404" data-name="Group 404" transform="translate(0 0)">
            <g id="Group_403" data-name="Group 403">
              <path
                id="Path_432"
                data-name="Path 432"
                d="M1396.608,1440.618a1.015,1.015,0,0,1-.719-1.734l6.661-6.661a.15.15,0,0,0,0-.212l-6.661-6.66a1.016,1.016,0,0,1,1.437-1.436l6.661,6.66a2.184,2.184,0,0,1,0,3.085l-6.661,6.661A1.011,1.011,0,0,1,1396.608,1440.618Z"
                transform="translate(-1395.592 -1423.618)"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  },
  Up() {
    return (
      <svg width="17" height="9.032" viewBox="0 0 17 9.032">
        <g
          id="Group_405"
          data-name="Group 405"
          transform="translate(0 9.032) rotate(-90)"
        >
          <g id="Group_404" data-name="Group 404" transform="translate(0 0)">
            <g id="Group_403" data-name="Group 403">
              <path
                id="Path_432"
                data-name="Path 432"
                d="M1396.608,1440.618a1.015,1.015,0,0,1-.719-1.734l6.661-6.661a.15.15,0,0,0,0-.212l-6.661-6.66a1.016,1.016,0,0,1,1.437-1.436l6.661,6.66a2.184,2.184,0,0,1,0,3.085l-6.661,6.661A1.011,1.011,0,0,1,1396.608,1440.618Z"
                transform="translate(-1395.592 -1423.618)"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  },
  Calendar() {
    return (
      <svg width="51.256" height="44.203" viewBox="0 0 51.256 44.203">
        <g
          id="Group_368"
          data-name="Group 368"
          transform="translate(-431.184 -479.984)"
        >
          <g
            id="Group_353"
            data-name="Group 353"
            transform="translate(431.184 479.984)"
          >
            <g
              id="Group_347"
              data-name="Group 347"
              transform="translate(0 13.998)"
            >
              <path
                id="Path_395"
                data-name="Path 395"
                d="M470.891,504.362h-38.6a1.105,1.105,0,0,1,0-2.21h38.6a1.105,1.105,0,0,1,0,2.21Z"
                transform="translate(-431.184 -502.152)"
              />
            </g>
            <g
              id="Group_348"
              data-name="Group 348"
              transform="translate(36.77 13.998)"
            >
              <path
                id="Path_396"
                data-name="Path 396"
                d="M502.8,504.362H490.522a1.105,1.105,0,1,1,0-2.21H502.8a1.105,1.105,0,0,1,0,2.21Z"
                transform="translate(-489.417 -502.152)"
              />
            </g>
            <g
              id="Group_349"
              data-name="Group 349"
              transform="translate(38.602)"
            >
              <path
                id="Path_397"
                data-name="Path 397"
                d="M493.423,489.193a1.105,1.105,0,0,1-1.105-1.1v-7a1.105,1.105,0,0,1,2.21,0v7A1.1,1.1,0,0,1,493.423,489.193Z"
                transform="translate(-492.318 -479.984)"
              />
            </g>
            <g
              id="Group_350"
              data-name="Group 350"
              transform="translate(10.47)"
            >
              <path
                id="Path_398"
                data-name="Path 398"
                d="M448.871,489.193a1.1,1.1,0,0,1-1.105-1.1v-7a1.105,1.105,0,0,1,2.21,0v7A1.105,1.105,0,0,1,448.871,489.193Z"
                transform="translate(-447.766 -479.984)"
              />
            </g>
            <g
              id="Group_351"
              data-name="Group 351"
              transform="translate(18.573 13.451)"
            >
              <path
                id="Path_399"
                data-name="Path 399"
                d="M488.649,532.038H461.7a1.105,1.105,0,1,1,0-2.21h26.946a2.4,2.4,0,0,0,2.394-2.394V502.391a1.105,1.105,0,1,1,2.21,0v25.043A4.61,4.61,0,0,1,488.649,532.038Z"
                transform="translate(-460.598 -501.286)"
              />
            </g>
            <g
              id="Group_352"
              data-name="Group 352"
              transform="translate(0.027 3.499)"
            >
              <path
                id="Path_400"
                data-name="Path 400"
                d="M452.782,526.23h-16.95a4.609,4.609,0,0,1-4.6-4.6V490.13a4.609,4.609,0,0,1,4.6-4.6h41.992a4.61,4.61,0,0,1,4.6,4.6v6.452a1.105,1.105,0,1,1-2.21,0V490.13a2.4,2.4,0,0,0-2.394-2.394H435.831a2.4,2.4,0,0,0-2.394,2.394v31.495a2.4,2.4,0,0,0,2.394,2.394h16.95a1.105,1.105,0,0,1,0,2.21Z"
                transform="translate(-431.227 -485.526)"
              />
            </g>
          </g>
          <g
            id="Group_367"
            data-name="Group 367"
            transform="translate(441.064 500.496)"
          >
            <g
              id="Group_354"
              data-name="Group 354"
              transform="translate(6.999 0)"
            >
              <rect
                id="Rectangle_330"
                data-name="Rectangle 330"
                width="3.499"
                height="3.499"
                rx="1.75"
              />
            </g>
            <g
              id="Group_355"
              data-name="Group 355"
              transform="translate(13.998 0)"
            >
              <rect
                id="Rectangle_331"
                data-name="Rectangle 331"
                width="3.499"
                height="3.499"
                rx="1.75"
              />
            </g>
            <g
              id="Group_356"
              data-name="Group 356"
              transform="translate(20.997 0)"
            >
              <rect
                id="Rectangle_332"
                data-name="Rectangle 332"
                width="3.499"
                height="3.499"
                rx="1.75"
              />
            </g>
            <g
              id="Group_357"
              data-name="Group 357"
              transform="translate(27.995 0)"
            >
              <rect
                id="Rectangle_333"
                data-name="Rectangle 333"
                width="3.499"
                height="3.499"
                rx="1.75"
              />
            </g>
            <g
              id="Group_358"
              data-name="Group 358"
              transform="translate(0 6.999)"
            >
              <rect
                id="Rectangle_334"
                data-name="Rectangle 334"
                width="3.499"
                height="3.499"
                rx="1.75"
              />
            </g>
            <g
              id="Group_359"
              data-name="Group 359"
              transform="translate(6.999 6.999)"
            >
              <rect
                id="Rectangle_335"
                data-name="Rectangle 335"
                width="3.499"
                height="3.499"
                rx="1.75"
              />
            </g>
            <g
              id="Group_360"
              data-name="Group 360"
              transform="translate(13.998 6.999)"
            >
              <rect
                id="Rectangle_336"
                data-name="Rectangle 336"
                width="3.499"
                height="3.499"
                rx="1.75"
              />
            </g>
            <g
              id="Group_361"
              data-name="Group 361"
              transform="translate(20.997 6.999)"
            >
              <rect
                id="Rectangle_337"
                data-name="Rectangle 337"
                width="3.499"
                height="3.499"
                rx="1.75"
              />
            </g>
            <g
              id="Group_362"
              data-name="Group 362"
              transform="translate(27.995 6.999)"
            >
              <rect
                id="Rectangle_338"
                data-name="Rectangle 338"
                width="3.499"
                height="3.499"
                rx="1.75"
              />
            </g>
            <g
              id="Group_363"
              data-name="Group 363"
              transform="translate(0 13.998)"
            >
              <rect
                id="Rectangle_339"
                data-name="Rectangle 339"
                width="3.499"
                height="3.499"
                rx="1.75"
              />
            </g>
            <g
              id="Group_364"
              data-name="Group 364"
              transform="translate(6.999 13.998)"
            >
              <rect
                id="Rectangle_340"
                data-name="Rectangle 340"
                width="3.499"
                height="3.499"
                rx="1.75"
              />
            </g>
            <g
              id="Group_365"
              data-name="Group 365"
              transform="translate(13.998 13.998)"
            >
              <rect
                id="Rectangle_341"
                data-name="Rectangle 341"
                width="3.499"
                height="3.499"
                rx="1.75"
              />
            </g>
            <g
              id="Group_366"
              data-name="Group 366"
              transform="translate(20.997 13.998)"
            >
              <rect
                id="Rectangle_342"
                data-name="Rectangle 342"
                width="3.499"
                height="3.499"
                rx="1.75"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  },
  Info() {
    return (
      <svg width="47.402" height="47.403" viewBox="0 0 47.402 47.403">
        <g
          id="Group_378"
          data-name="Group 378"
          transform="translate(-431.19 -1510.26)"
        >
          <g
            id="Group_375"
            data-name="Group 375"
            transform="translate(431.19 1510.26)"
          >
            <path
              id="Path_413"
              data-name="Path 413"
              d="M477.706,1557.663H454.689a23.7,23.7,0,1,1,23.9-24.336v23.449A.887.887,0,0,1,477.706,1557.663Zm-22.814-45.629a21.928,21.928,0,0,0-.195,43.854h22.122v-22.535A21.84,21.84,0,0,0,454.892,1512.034Z"
              transform="translate(-431.19 -1510.26)"
            />
          </g>
          <g
            id="Group_377"
            data-name="Group 377"
            transform="translate(452.915 1524.177)"
          >
            <g id="Group_376" data-name="Group 376">
              <path
                id="Path_414"
                data-name="Path 414"
                d="M477.793,1539.535a2.053,2.053,0,0,1-.558,1.369,1.842,1.842,0,0,1-1.318.558,1.789,1.789,0,0,1-.71-.152,4.231,4.231,0,0,1-.608-.406,1.823,1.823,0,0,1-.406-.608,1.852,1.852,0,0,1-.152-.76,1.4,1.4,0,0,1,.152-.659,4.228,4.228,0,0,1,.406-.608,1.821,1.821,0,0,1,.608-.406,1.621,1.621,0,0,1,.71-.152,1.791,1.791,0,0,1,.71.152,4.219,4.219,0,0,1,.608.406,1.436,1.436,0,0,1,.406.558A1.619,1.619,0,0,1,477.793,1539.535Zm-.2,15.463a1.811,1.811,0,0,1-.456,1.318,1.714,1.714,0,0,1-2.434,0,1.9,1.9,0,0,1-.456-1.318v-9.126a1.812,1.812,0,0,1,.456-1.318,1.714,1.714,0,0,1,2.434,0,1.9,1.9,0,0,1,.456,1.318Z"
                transform="translate(-474.041 -1537.71)"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  },
  Notification() {
    return (
      <svg width="46.047" height="46.095" viewBox="0 0 46.047 46.095">
        <g
          id="Group_383"
          data-name="Group 383"
          transform="translate(-462.433 -2048.493)"
        >
          <g
            id="Group_381"
            data-name="Group 381"
            transform="translate(484.136 2048.493)"
          >
            <path
              id="Path_417"
              data-name="Path 417"
              d="M519.8,2072.837a12.172,12.172,0,1,1,12.172-12.172A12.186,12.186,0,0,1,519.8,2072.837Zm0-22.664a10.491,10.491,0,1,0,10.492,10.491A10.5,10.5,0,0,0,519.8,2050.174Z"
              transform="translate(-507.632 -2048.493)"
            />
          </g>
          <g
            id="Group_382"
            data-name="Group 382"
            transform="translate(462.433 2051.566)"
          >
            <path
              id="Path_418"
              data-name="Path 418"
              d="M495.54,2097.915H472.348a9.926,9.926,0,0,1-9.915-9.915v-23.24a9.825,9.825,0,0,1,9.875-9.867h9.115a.84.84,0,1,1,0,1.68H472.3a7.961,7.961,0,0,0-5.752,2.337,8.173,8.173,0,0,0-2.434,5.85V2088a8.244,8.244,0,0,0,8.234,8.235H495.54a8.244,8.244,0,0,0,8.235-8.235v-9.123a.84.84,0,0,1,1.681,0V2088A9.926,9.926,0,0,1,495.54,2097.915Z"
              transform="translate(-462.433 -2054.893)"
            />
          </g>
        </g>
      </svg>
    );
  },
  Search() {
    return (
      <svg width="33.056" height="33.054" viewBox="0 0 33.056 33.054">
        <g
          id="Group_386"
          data-name="Group 386"
          transform="translate(-1355.688 -373.537)"
        >
          <path
            id="Path_420"
            data-name="Path 420"
            d="M1388.459,404.928l-9.712-9.712a13.286,13.286,0,1,0-1.38,1.371l9.712,9.712a.965.965,0,0,0,.69.292,1,1,0,0,0,.69-.282A.98.98,0,0,0,1388.459,404.928Zm-19.647-7.087a11.18,11.18,0,1,1,11.18-11.18A11.194,11.194,0,0,1,1368.811,397.841Z"
          />
        </g>
      </svg>
    );
  },
  Upload() {
    return (
      <svg width="44.431" height="39.879" viewBox="0 0 44.431 39.879">
        <g
          id="Group_389"
          data-name="Group 389"
          transform="translate(-1345.404 -880.066)"
        >
          <g
            id="Group_387"
            data-name="Group 387"
            transform="translate(1345.404 880.066)"
          >
            <path
              id="Path_421"
              data-name="Path 421"
              d="M1379.33,912.383h-7.268a.814.814,0,0,1,0-1.629h7.268a8.877,8.877,0,0,0,2-17.525.815.815,0,0,1-.621-.648,13.317,13.317,0,0,0-26.186,0,.815.815,0,0,1-.621.648,8.877,8.877,0,0,0,2,17.525h6.46a.814.814,0,0,1,0,1.629h-6.46a10.507,10.507,0,0,1-2.882-20.611,14.948,14.948,0,0,1,29.184,0,10.507,10.507,0,0,1-2.882,20.611Z"
              transform="translate(-1345.404 -880.066)"
            />
          </g>
          <g
            id="Group_388"
            data-name="Group 388"
            transform="translate(1361.362 897.696)"
          >
            <path
              id="Path_422"
              data-name="Path 422"
              d="M1391.874,923.613l-5.341-5.388a.819.819,0,0,0-1.265.047l-5.294,5.341c-.516.843-.375,1.405.89,1.453h3.96a.069.069,0,0,1,.069.069v14.033a1.008,1.008,0,0,0,.922,1.026,1.09,1.09,0,0,0,1.14-1.116v-13.99a.07.07,0,0,1,.069-.069h4.054C1392.2,924.925,1392.53,924.456,1391.874,923.613Z"
              transform="translate(-1379.693 -917.949)"
              fill-rule="evenodd"
            />
          </g>
        </g>
      </svg>
    );
  },
  Expand() {
    return (
      <svg width="55.031" height="31.192" viewBox="0 0 55.031 31.192">
        <g
          id="Group_402"
          data-name="Group 402"
          transform="translate(-1359.393 -1246.523)"
        >
          <g
            id="Group_397"
            data-name="Group 397"
            transform="translate(1377.6 1254.05)"
          >
            <g id="Group_396" data-name="Group 396" transform="translate(0)">
              <path
                id="Path_428"
                data-name="Path 428"
                d="M1411.119,1274.773l6.948-6.887a1.057,1.057,0,0,0-.061-1.632l-6.887-6.826c-1.087-.664-1.812-.483-1.873,1.148v5.106a.089.089,0,0,1-.089.089h-18.1a1.3,1.3,0,0,0-1.323,1.188,1.406,1.406,0,0,0,1.439,1.47h18.039a.089.089,0,0,1,.089.089v5.227C1409.427,1275.2,1410.031,1275.618,1411.119,1274.773Z"
                transform="translate(-1389.734 -1259.067)"
                fill-rule="evenodd"
              />
            </g>
          </g>
          <g
            id="Group_399"
            data-name="Group 399"
            transform="translate(1367.066 1254.05)"
          >
            <g id="Group_398" data-name="Group 398" transform="translate(0)">
              <path
                id="Path_429"
                data-name="Path 429"
                d="M1379.482,1259.5l-6.948,6.887a1.056,1.056,0,0,0,.061,1.631l6.887,6.826c1.087.665,1.812.484,1.873-1.147v-5.107a.089.089,0,0,1,.089-.089h18.1a1.3,1.3,0,0,0,1.323-1.188,1.406,1.406,0,0,0-1.439-1.47h-18.038a.089.089,0,0,1-.089-.089v-5.227C1381.174,1259.076,1380.569,1258.653,1379.482,1259.5Z"
                transform="translate(-1372.179 -1259.066)"
                fill-rule="evenodd"
              />
            </g>
          </g>
          <g
            id="Group_400"
            data-name="Group 400"
            transform="translate(1359.393 1246.523)"
          >
            <path
              id="Path_430"
              data-name="Path 430"
              d="M1360.443,1277.715a1.05,1.05,0,0,1-1.05-1.05v-29.092a1.05,1.05,0,1,1,2.1,0v29.092A1.05,1.05,0,0,1,1360.443,1277.715Z"
              transform="translate(-1359.393 -1246.523)"
            />
          </g>
          <g
            id="Group_401"
            data-name="Group 401"
            transform="translate(1412.324 1246.523)"
          >
            <path
              id="Path_431"
              data-name="Path 431"
              d="M1448.65,1277.715a1.05,1.05,0,0,1-1.05-1.05v-29.092a1.05,1.05,0,1,1,2.1,0v29.092A1.05,1.05,0,0,1,1448.65,1277.715Z"
              transform="translate(-1447.6 -1246.523)"
            />
          </g>
        </g>
      </svg>
    );
  },
  Back() {
    return (
      <svg width="32.824" height="25.402" viewBox="0 0 32.824 25.402">
        <path
          id="Path_433"
          data-name="Path 433"
          d="M1453.1,1649.438V1638.6a4.537,4.537,0,0,0-4.534-4.531h-23.944l6.6-6.592a1.272,1.272,0,1,0-1.8-1.8l-8.767,8.76a1.266,1.266,0,0,0-.276,1.391,1.294,1.294,0,0,0,.276.413l8.765,8.762a1.272,1.272,0,1,0,1.8-1.8l-6.594-6.591h23.944a1.99,1.99,0,0,1,1.987,1.985v10.833a1.273,1.273,0,0,0,2.547,0Z"
          transform="translate(-1420.276 -1625.308)"
        />
      </svg>
    );
  },
  Table() {
    return (
      <svg width="36.14" height="30.978" viewBox="0 0 36.14 30.978">
        <path
          id="Path_434"
          data-name="Path 434"
          d="M1453.835,1787.648h-30.977a2.582,2.582,0,0,0-2.582,2.581v25.814a2.583,2.583,0,0,0,2.582,2.582h30.977a2.582,2.582,0,0,0,2.581-2.582v-25.814A2.582,2.582,0,0,0,1453.835,1787.648Zm-10.326,7.745v5.162h-10.325v-5.162Zm0,7.744v5.163h-10.325v-5.163Zm-20.651-7.744h7.744v5.162h-7.744Zm0,7.744h7.744v5.163h-7.744Zm0,12.907v-5.162h7.744v5.162Zm10.325,0v-5.162h10.325v5.162Zm20.652,0h-7.744v-5.162h7.744Zm0-7.744h-7.744v-5.163h7.744Zm0-7.744h-7.744v-5.162h7.744Z"
          transform="translate(-1420.276 -1787.648)"
        />
      </svg>
    );
  },
  Cards() {
    return (
      <svg width="31.5" height="31.5" viewBox="0 0 31.5 31.5">
        <path
          id="Path_435"
          data-name="Path 435"
          d="M1414.314,1965.161h10.952a.453.453,0,0,1,.453.453v10.907a.453.453,0,0,1-.453.453h-10.952a.453.453,0,0,1-.453-.453v-10.907A.453.453,0,0,1,1414.314,1965.161Zm-1.526.453a1.525,1.525,0,0,1,1.526-1.525h10.952a1.525,1.525,0,0,1,1.525,1.525v10.907a1.525,1.525,0,0,1-1.525,1.525h-10.952a1.525,1.525,0,0,1-1.526-1.525Zm18.023-.453h10.953a.453.453,0,0,1,.452.453v10.907a.453.453,0,0,1-.452.453h-10.953a.453.453,0,0,1-.453-.453v-10.907A.453.453,0,0,1,1430.811,1965.161Zm-1.525.453a1.525,1.525,0,0,1,1.525-1.525h10.953a1.525,1.525,0,0,1,1.525,1.525v10.907a1.525,1.525,0,0,1-1.525,1.525h-10.953a1.525,1.525,0,0,1-1.525-1.525Zm-4.021,16.09h-10.952a.453.453,0,0,0-.453.453v10.907a.453.453,0,0,0,.453.453h10.952a.453.453,0,0,0,.453-.453v-10.907A.453.453,0,0,0,1425.265,1981.7Zm-10.952-1.072a1.525,1.525,0,0,0-1.526,1.525v10.907a1.525,1.525,0,0,0,1.526,1.525h10.952a1.525,1.525,0,0,0,1.525-1.525v-10.907a1.525,1.525,0,0,0-1.525-1.525Zm16.486,1.072h10.952a.453.453,0,0,1,.452.453v10.907a.453.453,0,0,1-.452.453H1430.8a.453.453,0,0,1-.453-.453v-10.907A.453.453,0,0,1,1430.8,1981.7Zm-1.525.453a1.525,1.525,0,0,1,1.525-1.525h10.952a1.525,1.525,0,0,1,1.525,1.525v10.907a1.525,1.525,0,0,1-1.525,1.525H1430.8a1.525,1.525,0,0,1-1.525-1.525Z"
          transform="translate(-1412.288 -1963.589)"
          stroke="#000"
          stroke-width="1"
          fill-rule="evenodd"
        />
      </svg>
    );
  },
  Rotate() {
    return (
      <svg width="39.701" height="39.701" viewBox="0 0 39.701 39.701">
        <g
          id="Group_407"
          data-name="Group 407"
          transform="translate(-1414.149 -2112.882)"
        >
          <path
            id="Path_436"
            data-name="Path 436"
            d="M1434,2112.882a19.854,19.854,0,0,0-15.588,7.57l-4.262-4.261v11.579h11.58l-4.96-4.959a16.54,16.54,0,1,1,13.23,26.463v3.309a19.85,19.85,0,1,0,0-39.7Z"
          />
        </g>
      </svg>
    );
  },
  Add() {
    return (
      <svg width="56.5" height="56.5" viewBox="0 0 56.5 56.5">
        <g
          id="Group_424"
          data-name="Group 424"
          transform="translate(-1351.699 -555.653)"
        >
          <path
            id="Path_439"
            data-name="Path 439"
            d="M1400.064,588.712h-12.576V576.136a1.314,1.314,0,1,0-2.628,0v12.576h-13.219a1.314,1.314,0,1,0,0,2.628h13.233v13.233a1.314,1.314,0,0,0,2.628,0V591.34h12.576a1.314,1.314,0,1,0-.014-2.628Z"
            transform="translate(-5.947 -6.12)"
          />
          <path
            id="Path_440"
            data-name="Path 440"
            d="M1379.951,555.653a28.253,28.253,0,1,0,19.974,8.279A28.247,28.247,0,0,0,1379.951,555.653Zm0,53.877a25.624,25.624,0,1,1,25.624-25.625A25.658,25.658,0,0,1,1379.951,609.53Z"
          />
        </g>
      </svg>
    );
  },
  Activity() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 25 25"
      >
        <g
          id="Group_493"
          data-name="Group 493"
          transform="translate(8057 -9195)"
        >
          <path
            id="Path_457"
            data-name="Path 457"
            d="M1429.442,2252.844h-5.981v-6.459a.5.5,0,0,0-1,0v7.456h6.977a.5.5,0,1,0,0-1Z"
            transform="translate(-9468.264 6955.621)"
            fill="#fff"
          />
          <g
            id="Path_458"
            data-name="Path 458"
            transform="translate(-8057 9195)"
            fill="none"
          >
            <path
              d="M 12.5 1 C 9.428239822387695 1 6.54033088684082 2.196210861206055 4.368270874023438 4.368270874023438 C 2.196210861206055 6.54033088684082 1 9.428239822387695 1 12.5 C 1 15.5717601776123 2.196210861206055 18.45967102050781 4.368270874023438 20.63172912597656 C 6.54033088684082 22.80379104614258 9.428239822387695 24 12.5 24 C 15.5717601776123 24 18.45967102050781 22.80379104614258 20.63172912597656 20.63172912597656 C 22.80379104614258 18.45967102050781 24 15.5717601776123 24 12.5 C 24 9.428239822387695 22.80379104614258 6.54033088684082 20.63172912597656 4.368270874023438 C 18.45967102050781 2.196210861206055 15.5717601776123 1 12.5 1 M 12.5 0 C 19.40356063842773 0 25 5.596439361572266 25 12.5 C 25 19.40356063842773 19.40356063842773 25 12.5 25 C 5.596439361572266 25 0 19.40356063842773 0 12.5 C 0 5.596439361572266 5.596439361572266 0 12.5 0 Z"
              stroke="none"
              fill="#fff"
            />
          </g>
        </g>
      </svg>
    );
  },
  Close() {
    return (
      <svg width="39.032" height="39.018" viewBox="0 0 39.032 39.018">
        <g
          id="Group_444"
          data-name="Group 444"
          transform="translate(-417.712 -687.068)"
        >
          <path
            id="Path_449"
            data-name="Path 449"
            d="M419.673,726.086a1.951,1.951,0,0,1-1.4-3.324l.012-.011L453.4,687.642a1.959,1.959,0,0,1,2.77,2.77L421.058,725.52A1.951,1.951,0,0,1,419.673,726.086Z"
          />
          <path
            id="Path_450"
            data-name="Path 450"
            d="M454.782,726.086a1.954,1.954,0,0,1-1.385-.566l-35.108-35.108a1.958,1.958,0,1,1,2.769-2.77l35.109,35.109a1.949,1.949,0,0,1,.011,2.758l-.011.011A1.951,1.951,0,0,1,454.782,726.086Z"
          />
        </g>
      </svg>
    );
  },
  Check() {
    return (
      <svg width="57" height="57" viewBox="0 0 57 57">
        <g
          id="Group_492"
          data-name="Group 492"
          transform="translate(-159 -241.527)"
        >
          <ellipse
            id="Ellipse_19"
            data-name="Ellipse 19"
            cx="28.5"
            cy="26.773"
            rx="28.5"
            ry="26.773"
            transform="translate(159 242.344)"
            fill="#fff"
          />
          <g id="noun_checkmark_569906" transform="translate(159 241.527)">
            <g id="Group_490" data-name="Group 490">
              <g id="Group_489" data-name="Group 489">
                <path
                  id="Path_456"
                  data-name="Path 456"
                  d="M46.889,387.759a1.462,1.462,0,0,0,.375-.272l20.15-20.15a1.462,1.462,0,0,0,0-2.067l-1.036-1.036a1.463,1.463,0,0,0-2.067,0L46.228,382.322l-8.007-8.006a1.46,1.46,0,0,0-2.068,0l-1.036,1.036a1.464,1.464,0,0,0,0,2.068l10.071,10.071A1.461,1.461,0,0,0,46.889,387.759ZM23,375.5A28.5,28.5,0,1,1,51.5,404,28.5,28.5,0,0,1,23,375.5Z"
                  transform="translate(-23 -347)"
                  fill="#62c376"
                  fill-rule="evenodd"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  },
  Prev() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9.032"
        height="17"
        viewBox="0 0 9.032 17"
      >
        <g
          id="Group_558"
          data-name="Group 558"
          transform="translate(9.032 17) rotate(180)"
        >
          <g id="Group_403" data-name="Group 403">
            <path
              id="Path_432"
              data-name="Path 432"
              d="M1396.608,1440.618a1.015,1.015,0,0,1-.719-1.734l6.661-6.661a.15.15,0,0,0,0-.212l-6.661-6.66a1.016,1.016,0,0,1,1.437-1.436l6.661,6.66a2.184,2.184,0,0,1,0,3.085l-6.661,6.661A1.011,1.011,0,0,1,1396.608,1440.618Z"
              transform="translate(-1395.592 -1423.618)"
              fill="#fff"
            />
          </g>
        </g>
      </svg>
    );
  },
  Next() {
    return (
      <svg
        id="Group_404"
        data-name="Group 404"
        xmlns="http://www.w3.org/2000/svg"
        width="9.032"
        height="17"
        viewBox="0 0 9.032 17"
      >
        <g id="Group_403" data-name="Group 403">
          <path
            id="Path_432"
            data-name="Path 432"
            d="M1396.608,1440.618a1.015,1.015,0,0,1-.719-1.734l6.661-6.661a.15.15,0,0,0,0-.212l-6.661-6.66a1.016,1.016,0,0,1,1.437-1.436l6.661,6.66a2.184,2.184,0,0,1,0,3.085l-6.661,6.661A1.011,1.011,0,0,1,1396.608,1440.618Z"
            transform="translate(-1395.592 -1423.618)"
            fill="#fff"
          />
        </g>
      </svg>
    );
  },
  Filter() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24.907"
        height="21.3"
        viewBox="0 0 94.907 91.3"
      >
        <g
          id="noun_customize_2434822_1_"
          data-name="noun_customize_2434822 (1)"
          transform="translate(-2.5 -4.3)"
        >
          <g id="Group_1034" data-name="Group 1034">
            <path
              id="Path_39899"
              data-name="Path 39899"
              d="M4.6,23.2H21.3v7.4a1.9,1.9,0,0,0,1.9,1.9H35.5a1.9,1.9,0,0,0,1.9-1.9V6.2a1.9,1.9,0,0,0-1.9-1.9H23.3a1.9,1.9,0,0,0-1.9,1.9v7.4H4.6a2.112,2.112,0,0,0-2.1,2.1V21A2.136,2.136,0,0,0,4.6,23.2Z"
            />
            <path
              id="Path_39900"
              data-name="Path 39900"
              d="M95.4,13.6H43.5v9.6H95.3a2.112,2.112,0,0,0,2.1-2.1V15.8A2,2,0,0,0,95.4,13.6Z"
            />
            <path
              id="Path_39901"
              data-name="Path 39901"
              d="M95.4,45.2H76.7v9.6H95.3a2.112,2.112,0,0,0,2.1-2.1V47.4A2,2,0,0,0,95.4,45.2Z"
            />
            <path
              id="Path_39902"
              data-name="Path 39902"
              d="M4.6,54.8H54.5v7.4a1.9,1.9,0,0,0,1.9,1.9H68.7a1.9,1.9,0,0,0,1.9-1.9V37.8a1.9,1.9,0,0,0-1.9-1.9H56.5a1.9,1.9,0,0,0-1.9,1.9v7.4H4.6a2.112,2.112,0,0,0-2.1,2.1v5.3A2.136,2.136,0,0,0,4.6,54.8Z"
            />
            <path
              id="Path_39903"
              data-name="Path 39903"
              d="M95.4,76.8H43.5v9.6H95.3a2.112,2.112,0,0,0,2.1-2.1V79A2.056,2.056,0,0,0,95.4,76.8Z"
            />
            <path
              id="Path_39904"
              data-name="Path 39904"
              d="M35.5,67.5H23.3a1.9,1.9,0,0,0-1.9,1.9v7.4H4.6a2.112,2.112,0,0,0-2.1,2.1v5.3a2.112,2.112,0,0,0,2.1,2.1H21.3v7.4a1.9,1.9,0,0,0,1.9,1.9H35.5a1.9,1.9,0,0,0,1.9-1.9V69.4A1.839,1.839,0,0,0,35.5,67.5Z"
            />
          </g>
        </g>
      </svg>
    );
  },
  Burger() {
    return (
      <svg width="15.892" height="16" viewBox="0 0 15.892 16">
        <g id="noun_menu_1166841" transform="translate(-13.5 -13)">
          <path
            id="Path_39887"
            data-name="Path 39887"
            d="M24.39,46.882h-9.7A1.2,1.2,0,0,1,13.5,45.691h0A1.2,1.2,0,0,1,14.691,44.5h9.721A1.2,1.2,0,0,1,25.6,45.691h0A1.22,1.22,0,0,1,24.39,46.882Z"
            transform="translate(0 -24.68)"
            fill="#4e35c2"
          />
          <path
            id="Path_39888"
            data-name="Path 39888"
            d="M20.19,78.282h-5.5A1.2,1.2,0,0,1,13.5,77.091h0A1.2,1.2,0,0,1,14.691,75.9h5.5a1.2,1.2,0,0,1,1.191,1.191h0A1.187,1.187,0,0,1,20.19,78.282Z"
            transform="translate(0 -49.282)"
            fill="#4e35c2"
          />
          <path
            id="Path_39889"
            data-name="Path 39889"
            d="M28.179,15.382H14.691A1.2,1.2,0,0,1,13.5,14.191h0A1.2,1.2,0,0,1,14.691,13H28.2a1.2,1.2,0,0,1,1.191,1.191h0A1.22,1.22,0,0,1,28.179,15.382Z"
            transform="translate(0)"
            fill="#4e35c2"
          />
        </g>
      </svg>
    );
  },
  Toggle() {
    return (
      <svg width="16.633" height="16.001" viewBox="0 0 16.633 16.001">
        <g id="noun_customize_2434822" transform="translate(-2.5 -4.3)">
          <g
            id="Group_1022"
            data-name="Group 1022"
            transform="translate(2.5 4.3)"
          >
            <path
              id="Path_39891"
              data-name="Path 39891"
              d="M2.868,7.612H5.795v1.3a.333.333,0,0,0,.333.333H8.283a.333.333,0,0,0,.333-.333V4.633A.333.333,0,0,0,8.283,4.3H6.145a.333.333,0,0,0-.333.333v1.3H2.868A.37.37,0,0,0,2.5,6.3v.929A.374.374,0,0,0,2.868,7.612Z"
              transform="translate(-2.5 -4.3)"
              fill="#4e35c2"
            />
            <path
              id="Path_39892"
              data-name="Path 39892"
              d="M52.6,13.6H43.5v1.682h9.078a.37.37,0,0,0,.368-.368v-.929A.351.351,0,0,0,52.6,13.6Z"
              transform="translate(-36.315 -11.97)"
              fill="#4e35c2"
            />
            <path
              id="Path_39893"
              data-name="Path 39893"
              d="M79.977,45.2H76.7v1.682h3.26a.37.37,0,0,0,.368-.368v-.929A.351.351,0,0,0,79.977,45.2Z"
              transform="translate(-63.696 -38.032)"
              fill="#4e35c2"
            />
            <path
              id="Path_39894"
              data-name="Path 39894"
              d="M2.868,39.212h8.745v1.3a.333.333,0,0,0,.333.333H14.1a.333.333,0,0,0,.333-.333V36.233A.333.333,0,0,0,14.1,35.9H11.964a.333.333,0,0,0-.333.333v1.3H2.868A.37.37,0,0,0,2.5,37.9v.929A.374.374,0,0,0,2.868,39.212Z"
              transform="translate(-2.5 -30.362)"
              fill="#4e35c2"
            />
            <path
              id="Path_39895"
              data-name="Path 39895"
              d="M52.6,76.8H43.5v1.682h9.078a.37.37,0,0,0,.368-.368v-.929A.36.36,0,0,0,52.6,76.8Z"
              transform="translate(-36.315 -64.094)"
              fill="#4e35c2"
            />
            <path
              id="Path_39896"
              data-name="Path 39896"
              d="M8.283,67.5H6.145a.333.333,0,0,0-.333.333v1.3H2.868A.37.37,0,0,0,2.5,69.5v.929a.37.37,0,0,0,.368.368H5.795v1.3a.333.333,0,0,0,.333.333H8.283a.333.333,0,0,0,.333-.333V67.833A.322.322,0,0,0,8.283,67.5Z"
              transform="translate(-2.5 -56.424)"
              fill="#4e35c2"
            />
          </g>
        </g>
      </svg>
    );
  },
  Logo() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="109.9"
        height="76.137"
        viewBox="0 0 109.9 76.137"
      >
        <g
          id="Group_1013"
          data-name="Group 1013"
          transform="translate(18514.439 16536.539)"
        >
          <path
            id="Path_39886"
            data-name="Path 39886"
            d="M44.053,91.244c-.028,0-.053,0-.081,0a11.085,11.085,0,0,1-9.594-5.564L13.631,49.986a11.208,11.208,0,0,1,4-15.266l.055-.033A11.188,11.188,0,0,1,33.043,38.7l20.72,35.668a11.192,11.192,0,0,1-.08,11.373l-.042.065a11.082,11.082,0,0,1-9.589,5.434"
            transform="translate(-18526.561 -16551.646)"
            fill="#f5a623"
          />
          <path
            id="Path_39887"
            data-name="Path 39887"
            d="M65.193,98.352h-.038a11.088,11.088,0,0,1-9.643-5.579L34.877,57.148a11.213,11.213,0,0,1,4-15.244l.04-.023a11.187,11.187,0,0,1,15.4,4.06L65.246,64.993,87.138,27.8a11.188,11.188,0,0,1,19.285,11.348L74.836,92.836a11.083,11.083,0,0,1-9.643,5.515"
            transform="translate(-18512.502 -16558.822)"
            fill="#f5a623"
          />
        </g>
      </svg>
    );
  },
  Recent() {
    return (
      <svg
        style={{ width: "30px" }}
        width="77.571"
        height="82.165"
        viewBox="0 0 77.571 82.165"
      >
        <g
          id="Group_483"
          data-name="Group 483"
          transform="translate(-426.392 -511.75)"
        >
          <g
            id="Group_344"
            data-name="Group 344"
            transform="translate(426.392 514.72)"
          >
            <path
              id="Path_392"
              data-name="Path 392"
              d="M464.366,593A39.387,39.387,0,0,1,426.5,565.028a2.526,2.526,0,1,1,4.829-1.481,34.546,34.546,0,1,0,14.911-39.556,2.527,2.527,0,1,1-2.657-4.3A39.6,39.6,0,1,1,464.366,593Z"
              transform="translate(-426.392 -513.807)"
            />
          </g>
          <g
            id="Group_345"
            data-name="Group 345"
            transform="translate(437.734 511.75)"
          >
            <path
              id="Path_393"
              data-name="Path 393"
              d="M448.312,531.239a2.533,2.533,0,0,1-.617-.078l-11.537-2.9a2.526,2.526,0,0,1-1.834-3.065l2.9-11.537a2.526,2.526,0,1,1,4.9,1.232l-2.281,9.086,9.086,2.283a2.527,2.527,0,0,1-.615,4.978Z"
              transform="translate(-434.248 -511.75)"
            />
          </g>
          <g
            id="Group_346"
            data-name="Group 346"
            transform="translate(449.27 536.001)"
          >
            <path
              id="Path_394"
              data-name="Path 394"
              d="M462,552.242h-.035l-17.231-.227a2.527,2.527,0,0,1,.033-5.053h.035l14.672.192V531.074a2.527,2.527,0,1,1,5.053,0v18.642A2.526,2.526,0,0,1,462,552.242Z"
              transform="translate(-442.238 -528.547)"
            />
          </g>
        </g>
      </svg>
    );
  },
  Timeline() {
    return <ChartBarHorizontal />;
  },
  Projects() {
    return <FolderNotchOpen />;
  },
  People() {
    return <Graph />;
  },
  Workspaces() {
    return <Cube />;
  },
  Clients() {
    return <AddressBook />;
  },
  Dashboard() {
    return <Cards />;
  },
  Settings() {
    return <GearSix />;
  },
  Messages() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="147.268"
        height="147.188"
        viewBox="0 0 147.268 147.188"
      >
        <g id="noun_chat_3876254" transform="translate(0 -0.001)">
          <g id="Layer_3" data-name="Layer 3" transform="translate(0 0.001)">
            <path
              id="Path_40181"
              data-name="Path 40181"
              d="M76.594,3A73.55,73.55,0,0,0,10.63,109.166L3.108,144.256a4.906,4.906,0,0,0,6.064,5.765l32.543-8.664A73.594,73.594,0,1,0,76.594,3Zm0,90.766H47.157a4.906,4.906,0,1,1,0-9.812H76.594a4.906,4.906,0,1,1,0,9.812Zm29.437-24.531H47.157a4.906,4.906,0,1,1,0-9.812h58.875a4.906,4.906,0,1,1,0,9.812Z"
              transform="translate(-3 -3)"
              fill="#d1cbbe"
            />
          </g>
        </g>
      </svg>
    );
  },
  Invoices() {
    return (
      <svg width="47.938" height="35.939" viewBox="0 0 47.938 35.939">
        <g
          id="Group_395"
          data-name="Group 395"
          transform="translate(-1282.404 -1014.102)"
        >
          <g
            id="Group_390"
            data-name="Group 390"
            transform="translate(1282.404 1024.44)"
          >
            <path
              id="Path_423"
              data-name="Path 423"
              d="M1329.206,1055.616h-45.665a1.137,1.137,0,0,1-1.137-1.137v-23.3a1.137,1.137,0,0,1,2.274,0v22.164h43.391v-22.19a1.137,1.137,0,0,1,2.274,0v23.327A1.136,1.136,0,0,1,1329.206,1055.616Z"
              transform="translate(-1282.404 -1030.015)"
            />
          </g>
          <g
            id="Group_391"
            data-name="Group 391"
            transform="translate(1288.098 1024.44)"
          >
            <path
              id="Path_424"
              data-name="Path 424"
              d="M1326.583,1032.289H1292.3a1.137,1.137,0,1,1,0-2.274h34.279a1.137,1.137,0,1,1,0,2.274Z"
              transform="translate(-1291.168 -1030.015)"
            />
          </g>
          <g
            id="Group_392"
            data-name="Group 392"
            transform="translate(1291.74 1019.271)"
          >
            <path
              id="Path_425"
              data-name="Path 425"
              d="M1324.9,1024.332h-26.994a1.137,1.137,0,0,1,0-2.274H1324.9a1.137,1.137,0,1,1,0,2.274Z"
              transform="translate(-1296.774 -1022.058)"
            />
          </g>
          <g
            id="Group_393"
            data-name="Group 393"
            transform="translate(1295.081 1014.102)"
          >
            <path
              id="Path_426"
              data-name="Path 426"
              d="M1323.366,1016.376h-20.312a1.137,1.137,0,0,1,0-2.274h20.312a1.137,1.137,0,1,1,0,2.274Z"
              transform="translate(-1301.917 -1014.102)"
            />
          </g>
          <g
            id="Group_394"
            data-name="Group 394"
            transform="translate(1298.86 1030.687)"
          >
            <path
              id="Path_427"
              data-name="Path 427"
              d="M1321.658,1045.205h-12.787a1.137,1.137,0,0,1-1.137-1.137v-3.3a1.137,1.137,0,0,1,2.274,0v2.165h10.513v-2.165a1.137,1.137,0,0,1,2.274,0v3.3A1.137,1.137,0,0,1,1321.658,1045.205Z"
              transform="translate(-1307.734 -1039.63)"
            />
          </g>
        </g>
      </svg>
    );
  },
  Managers() {
    return (
      <svg
        height="639pt"
        viewBox="-19 -19 639 639.99991"
        width="639pt"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m540.5 330v-20c5.519531 0 10-4.476562 10-10v-60c0-5.523438-4.480469-10-10-10h-54l-1.9375-7.511719c-4.421875-17.179687-11.289062-33.636719-20.402344-48.859375l-4-6.691406 38.339844-38.40625c3.859375-3.867188 3.859375-10.132812 0-14l-42.46875-42.53125c-3.921875-3.738281-10.082031-3.738281-14.003906 0l-38.410156 38.410156-6.6875-4c-15.246094-9.117187-31.71875-15.984375-48.921876-20.410156l-7.507812-1.953125v-54.046875c0-5.523438-4.476562-10-10-10h-60c-5.523438 0-10 4.476562-10 10v54l-7.511719 1.941406c-17.179687 4.417969-33.636719 11.285156-48.867187 20.386719l-6.691406 4.003906-38.398438-38.332031c-3.925781-3.769531-10.125-3.769531-14.050781 0l-42.480469 42.46875c-1.867188 1.863281-2.917969 4.394531-2.917969 7.03125 0 2.640625 1.050781 5.167969 2.917969 7.03125l38.410156 38.40625-4 6.691406c-9.109375 15.222656-15.980468 31.679688-20.398437 48.859375l-1.960938 7.511719h-54.050781c-5.523438 0-10 4.476562-10 10v60c0 5.523438 4.476562 10 10 10v20c-16.566406 0-30-13.433594-30-30v-60c0-16.566406 13.433594-30 30-30h38.691406c4.125-13.828125 9.703125-27.179688 16.640625-39.828125l-27.5-27.5c-5.625-5.613281-8.785156-13.230469-8.785156-21.171875s3.160156-15.558594 8.785156-21.167969l42.5-42.5c11.839844-11.332031 30.507813-11.332031 42.347657 0l27.492187 27.488281c12.648437-6.933593 26.003906-12.5 39.828125-16.621093v-38.699219c0-16.566406 13.433594-30 30-30h60c16.566406 0 30 13.433594 30 30v38.699219c13.828125 4.121093 27.175781 9.699219 39.828125 16.632812l27.5-27.5c11.84375-11.332031 30.507813-11.332031 42.351563 0l42.492187 42.488281c5.621094 5.613282 8.777344 13.222657 8.777344 21.167969 0 7.945313-3.15625 15.5625-8.777344 21.171875l-27.5 27.5c6.933594 12.65625 12.507813 26.011719 16.636719 39.839844h38.691406c16.566406 0 30 13.433594 30 30v60c0 16.566406-13.433594 30-30 30zm0 0" />
        <path d="m440.5 270h-20c0-66.273438-53.726562-120-120-120s-120 53.726562-120 120h-20c0-77.320312 62.679688-140 140-140 77.316406 0 140 62.679688 140 140zm0 0" />
        <path d="m300.5 350c-33.136719 0-60-26.867188-60-60 0-33.136719 26.863281-60 60-60 33.140625 0 60 26.863281 60 60-.035156 33.125-26.875 59.964844-60 60zm0-100c-22.089844 0-40 17.910156-40 40s17.910156 40 40 40 40-17.910156 40-40-17.910156-40-40-40zm0 0" />
        <path d="m470.5 390c-33.136719 0-60-26.867188-60-60 0-33.136719 26.863281-60 60-60s60 26.863281 60 60c-.035156 33.125-26.875 59.964844-60 60zm0-100c-22.089844 0-40 17.910156-40 40s17.910156 40 40 40 40-17.910156 40-40-17.910156-40-40-40zm0 0" />
        <path d="m130.5 390c-33.136719 0-60-26.867188-60-60 0-33.136719 26.863281-60 60-60 33.140625 0 60 26.863281 60 60-.035156 33.125-26.875 59.964844-60 60zm0-100c-22.089844 0-40 17.910156-40 40s17.910156 40 40 40 40-17.910156 40-40-17.910156-40-40-40zm0 0" />
        <path d="m561.15625 415.65625c-14.902344-10.242188-32.570312-15.707031-50.65625-15.65625h-80c-4.863281.042969-9.71875.484375-14.511719 1.316406-6.398437-10.007812-14.722656-18.640625-24.488281-25.410156-1.464844-1.105469-3.003906-2.109375-4.609375-2.996094-13.988281-8.472656-30.039063-12.933594-46.390625-12.910156h-80c-30.582031-.109375-59.078125 15.496094-75.460938 41.316406-4.804687-.832031-9.667968-1.273437-14.539062-1.316406h-80c-18.070312-.050781-35.734375 5.40625-50.628906 15.636719-24.617188 16.75-39.355469 44.589843-39.371094 74.363281v40c.035156 27.304688 15.921875 52.101562 40.722656 63.539062 9.15625 4.3125 19.160156 6.519532 29.277344 6.460938h100v-20h-90v-110h-20v108.996094c-3.765625-.753906-7.421875-1.972656-10.890625-3.617188-17.714844-8.167968-29.070313-25.875-29.109375-45.378906v-40c.023438-23.171875 11.503906-44.832031 30.660156-57.863281 11.574219-7.945313 25.296875-12.175781 39.339844-12.136719h80c1.761719 0 3.460938.1875 5.179688.304688-3.382813 9.539062-5.136719 19.578124-5.179688 29.695312v100c.035156 27.601562 22.402344 49.964844 50 50h30v-160h-20v140h-10c-16.566406 0-30-13.433594-30-30v-100c0-38.664062 31.34375-70 70-70h80c12.867188.007812 25.476562 3.570312 36.449219 10.289062 1.015625.554688 1.992187 1.179688 2.917969 1.867188 9.371093 6.417969 17.0625 14.992188 22.421874 25 5.386719 10.109375 8.210938 21.386719 8.210938 32.84375v100c0 16.566406-13.433594 30-30 30h-10v-140h-20v160h30c27.601562-.035156 49.964844-22.398438 50-50v-100c-.046875-10.117188-1.792969-20.152344-5.171875-29.695312 1.722656-.117188 3.421875-.304688 5.171875-.304688h80c14.050781-.039062 27.785156 4.203125 39.367188 12.15625 19.140624 13.039062 30.605468 34.683594 30.632812 57.84375v40c-.035156 19.574219-11.476562 37.332031-29.277344 45.457031-3.417968 1.617188-7.019531 2.804688-10.722656 3.539063v-108.996094h-20v110h-90v20h100c10.058594.0625 20.003906-2.117188 29.109375-6.382812 24.882813-11.402344 40.851563-36.246094 40.890625-63.617188v-40c-.015625-29.761719-14.742188-57.589844-39.34375-74.34375zm0 0" />
        <path d="m260.5 580h80v20h-80zm0 0" />
      </svg>
    );
  },
  CheckMark() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="291.846"
        height="310.799"
        viewBox="0 0 291.846 310.799"
      >
        <path
          id="Path_40134"
          data-name="Path 40134"
          d="M-699.254,99.911a45.088,45.088,0,0,0-22.6,6.1,45.084,45.084,0,0,0-21.134,27.543,45.061,45.061,0,0,0,4.532,34.422l74.469,128.982a44.15,44.15,0,0,0,26.976,20.7A44.112,44.112,0,0,0-603.3,313.22l1.411-.814A44.408,44.408,0,0,0-583.858,292.8l.738-1.23L-458.726,76.147A44.47,44.47,0,0,0-454.254,42.2a44.452,44.452,0,0,0-20.851-27.163l0-.006-1.067-.617a44.444,44.444,0,0,0-33.946-4.466,44.44,44.44,0,0,0-27.169,20.845l-81.352,140.905a7.482,7.482,0,0,1-6.46,3.728,7.48,7.48,0,0,1-6.459-3.728L-659.9,122.608a45.071,45.071,0,0,0-27.542-21.134A45.585,45.585,0,0,0-699.254,99.911Z"
          transform="translate(744.559 -8.398)"
          fill="#62c376"
        />
      </svg>
    );
  },
  Pause() {
    return (
      <svg
        width="20"
        height="32"
        viewBox="0 0 14 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.92312 0.290643C3.58816 0.0998219 3.20836 -0.000413868 2.82186 1.28437e-06C2.43537 0.000416437 2.05578 0.101469 1.72124 0.293009C1.38669 0.484549 1.10898 0.759832 0.915972 1.09121C0.722969 1.42258 0.62148 1.79838 0.621696 2.18086V12.0857C0.614831 12.3763 0.666742 12.6654 0.774377 12.9358C0.882011 13.2063 1.04319 13.4527 1.24846 13.6607C1.45372 13.8686 1.69891 14.0338 1.96963 14.1466C2.24034 14.2594 2.53112 14.3175 2.82485 14.3175C3.11859 14.3175 3.40936 14.2594 3.68008 14.1466C3.95079 14.0338 4.19599 13.8686 4.40125 13.6607C4.60651 13.4527 4.7677 13.2063 4.87533 12.9358C4.98296 12.6654 5.03487 12.3763 5.02801 12.0857V2.18086C5.02798 1.79749 4.92583 1.4209 4.73185 1.08905C4.53788 0.757193 4.25893 0.481805 3.92312 0.290643Z"
          fill="white"
        />
        <path
          d="M11.6571 0.290702C11.3221 0.099968 10.9422 -0.000199516 10.5557 0.000245618C10.1692 0.000690752 9.78954 0.101734 9.45494 0.293239C9.12033 0.484744 8.84252 0.759973 8.64936 1.0913C8.45621 1.42263 8.35452 1.79841 8.35449 2.18092V12.0858C8.35449 12.6642 8.58667 13.2189 8.99996 13.6279C9.41324 14.0369 9.97378 14.2666 10.5583 14.2666C11.1427 14.2666 11.7033 14.0369 12.1165 13.6279C12.5298 13.2189 12.762 12.6642 12.762 12.0858V2.18092C12.762 1.79755 12.6598 1.42096 12.4659 1.0891C12.2719 0.757252 11.9929 0.481864 11.6571 0.290702Z"
          fill="white"
        />
      </svg>
    );
  },
  PauseColor() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="249.939"
        height="296.75"
        viewBox="0 0 249.939 296.75"
      >
        <g
          id="Group_1533"
          data-name="Group 1533"
          transform="translate(338.613 -15.423)"
        >
          <path
            id="Path_40127"
            data-name="Path 40127"
            d="M-270.642,21.469a45.05,45.05,0,0,0-22.612-6.046,45.414,45.414,0,0,0-45.359,45.362l0,206.031a45.4,45.4,0,0,0,45.358,45.357,45.414,45.414,0,0,0,45.359-45.362l0-206.031A45.386,45.386,0,0,0-270.642,21.469Z"
            fill="#f5a623"
          />
          <path
            id="Path_40128"
            data-name="Path 40128"
            d="M-111.422,21.469a45.05,45.05,0,0,0-22.612-6.046,45.414,45.414,0,0,0-45.359,45.362l0,206.031a45.4,45.4,0,0,0,45.358,45.357,45.414,45.414,0,0,0,45.359-45.362l0-206.031A45.386,45.386,0,0,0-111.422,21.469Z"
            fill="#f5a623"
          />
        </g>
      </svg>
    );
  },
  Play() {
    return (
      <svg
        width="25"
        height="28"
        viewBox="0 0 25 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.71605 28C3.06901 27.9992 2.43367 27.8256 1.87442 27.4969C1.30085 27.1658 0.824889 26.6863 0.495481 26.1078C0.166073 25.5294 -0.00489828 24.8728 0.000106816 24.2055V3.76106C-0.000692886 3.10685 0.16971 2.46402 0.494084 1.89779C0.818459 1.33155 1.28528 0.862079 1.84719 0.536816C2.41189 0.194925 3.05602 0.0098554 3.71432 0.000383002C4.37261 -0.0090894 5.0217 0.157292 5.59582 0.482797H5.60233L23.0803 10.705C23.6521 11.0148 24.1315 11.4735 24.4687 12.0334C24.8059 12.5934 24.9888 13.2344 24.9982 13.8897C25.0188 14.5636 24.8601 15.2308 24.5387 15.8217C24.2173 16.4126 23.7449 16.9056 23.1708 17.2494L5.60124 27.4759C5.02944 27.8152 4.37915 27.996 3.71605 28Z"
          fill="white"
        />
      </svg>
    );
  },
  PlayBtn() {
    return (
      <svg
        width="28"
        height="31"
        viewBox="0 0 28 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.15996 31C3.43545 30.999 2.72407 30.8068 2.0979 30.4428C1.45586 30.0761 0.923146 29.5453 0.554478 28.905C0.185809 28.2646 -0.00552925 27.5379 0.000121635 26.7993V4.16443C-0.000868816 3.4401 0.189896 2.72839 0.553082 2.1014C0.916267 1.47441 1.43897 0.954425 2.06821 0.594165C2.70079 0.215646 3.42231 0.0108281 4.15968 0.000417663C4.89704 -0.00999276 5.62407 0.174376 6.2671 0.534885L6.27447 0.539129L25.85 11.8568C26.4905 12.1998 27.0274 12.7077 27.4051 13.3277C27.7828 13.9478 27.9875 14.6574 27.998 15.3831C28.0211 16.1291 27.8434 16.8677 27.4835 17.5218C27.1236 18.176 26.5947 18.7218 25.9518 19.1025L6.27358 30.4257C5.63194 30.7996 4.90284 30.9977 4.15996 31V31Z"
          fill="#62C376"
        />
      </svg>
    );
  },
  Continue() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="310.838"
        height="344.622"
        viewBox="0 0 310.838 344.622"
      >
        <path
          id="Path_40135"
          data-name="Path 40135"
          d="M497.519,2067.78a45.633,45.633,0,0,1-22.893-6.187,46.257,46.257,0,0,1-23.3-40.506V1769.456a45.677,45.677,0,0,1,22.96-39.691,46.452,46.452,0,0,1,46.614-.659l.083.047L738.3,1854.97a45.228,45.228,0,0,1,23.847,39.2,46.405,46.405,0,0,1-22.716,41.347L520.974,2061.4A46.852,46.852,0,0,1,497.519,2067.78Z"
          transform="translate(-451.325 -1723.158)"
          fill="#4e35c2"
        />
      </svg>
    );
  },
  Stop() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="252.616"
        height="252.616"
        viewBox="0 0 252.616 252.616"
      >
        <g
          id="Group_2317"
          data-name="Group 2317"
          transform="translate(-28.446 -37.49)"
        >
          <g id="Group_1530" data-name="Group 1530">
            <path
              id="Path_40130"
              data-name="Path 40130"
              d="M86.308,42.637A38.6,38.6,0,0,0,28.446,76.106l0,175.389a38.612,38.612,0,1,0,77.225,0l0-175.389A38.635,38.635,0,0,0,86.308,42.637Z"
              fill="#fff"
            />
            <path
              id="Path_40131"
              data-name="Path 40131"
              d="M261.7,42.637a38.6,38.6,0,0,0-57.863,33.469l0,175.389a38.613,38.613,0,1,0,77.226,0l0-175.389A38.632,38.632,0,0,0,261.7,42.637Z"
              fill="#fff"
            />
            <path
              id="Path_40132"
              data-name="Path 40132"
              d="M33.592,56.855a38.6,38.6,0,0,0,33.469,57.862l175.389,0a38.612,38.612,0,1,0,0-77.225l-175.389,0A38.635,38.635,0,0,0,33.592,56.855Z"
              fill="#fff"
            />
            <path
              id="Path_40133"
              data-name="Path 40133"
              d="M33.592,232.244a38.6,38.6,0,0,0,33.469,57.862l175.389,0a38.613,38.613,0,1,0,0-77.225l-175.389,0A38.635,38.635,0,0,0,33.592,232.244Z"
              fill="#fff"
            />
            <rect
              id="Rectangle_1355"
              data-name="Rectangle 1355"
              width="203.771"
              height="183.607"
              transform="translate(51.123 80.613)"
              fill="#fff"
            />
          </g>
        </g>
      </svg>
    );
  },
  StopCheck() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="252.616"
        height="252.616"
        viewBox="0 0 252.616 252.616"
      >
        <defs>
          <linearGradient
            id="linear-gradient"
            y1="0.5"
            x2="1"
            y2="0.5"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#dc322c" />
            <stop offset="0.997" stopColor="#dc322c" />
          </linearGradient>
        </defs>
        <g
          id="Group_1534"
          data-name="Group 1534"
          transform="translate(-28.446 -37.49)"
        >
          <g id="Group_1530" data-name="Group 1530">
            <path
              id="Path_40130"
              data-name="Path 40130"
              d="M86.308,42.637A38.6,38.6,0,0,0,28.446,76.106l0,175.389a38.612,38.612,0,1,0,77.225,0l0-175.389A38.635,38.635,0,0,0,86.308,42.637Z"
              fill="url(#linear-gradient)"
            />
            <path
              id="Path_40131"
              data-name="Path 40131"
              d="M261.7,42.637a38.6,38.6,0,0,0-57.863,33.469l0,175.389a38.613,38.613,0,1,0,77.226,0l0-175.389A38.632,38.632,0,0,0,261.7,42.637Z"
              fill="url(#linear-gradient)"
            />
            <path
              id="Path_40132"
              data-name="Path 40132"
              d="M33.592,56.855a38.6,38.6,0,0,0,33.469,57.862l175.389,0a38.612,38.612,0,1,0,0-77.225l-175.389,0A38.635,38.635,0,0,0,33.592,56.855Z"
              fill="url(#linear-gradient)"
            />
            <path
              id="Path_40133"
              data-name="Path 40133"
              d="M33.592,232.244a38.6,38.6,0,0,0,33.469,57.862l175.389,0a38.613,38.613,0,1,0,0-77.225l-175.389,0A38.635,38.635,0,0,0,33.592,232.244Z"
              fill="url(#linear-gradient)"
            />
            <rect
              id="Rectangle_1355"
              data-name="Rectangle 1355"
              width="203.771"
              height="183.607"
              transform="translate(51.123 80.613)"
              fill="url(#linear-gradient)"
            />
          </g>
        </g>
      </svg>
    );
  },
  Clock() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="133.44"
        height="133.44"
        viewBox="0 0 133.44 133.44"
      >
        <g
          id="Layer_3"
          data-name="Layer 3"
          transform="translate(-86.02 -89.51)"
        >
          <circle
            id="Ellipse_242"
            data-name="Ellipse 242"
            cx="66.72"
            cy="66.72"
            r="66.72"
            transform="translate(86.02 89.51)"
            fill="#4e35c2"
          />
          <path
            id="Path_40136"
            data-name="Path 40136"
            d="M175.96,179.44l-23.22-23.21V123.39"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="13"
          />
        </g>
      </svg>
    );
  },
  PDF() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="56px"
        height="64px"
        viewBox="0 0 56 64"
        enable-background="new 0 0 56 64"
      >
        <g>
          <path
            fill="#8C181A"
            d="M5.1,0C2.3,0,0,2.3,0,5.1v53.8C0,61.7,2.3,64,5.1,64h45.8c2.8,0,5.1-2.3,5.1-5.1V20.3L37.1,0H5.1z"
          />
          <path
            fill="#6B0D12"
            d="M56,20.4v1H43.2c0,0-6.3-1.3-6.1-6.7c0,0,0.2,5.7,6,5.7H56z"
          />
          <path
            opacity="0.5"
            fill="#FFFFFF"
            enable-background="new    "
            d="M37.1,0v14.6c0,1.7,1.1,5.8,6.1,5.8H56L37.1,0z"
          />
        </g>
        <path
          fill="#FFFFFF"
          d="M14.9,49h-3.3v4.1c0,0.4-0.3,0.7-0.8,0.7c-0.4,0-0.7-0.3-0.7-0.7V42.9c0-0.6,0.5-1.1,1.1-1.1h3.7
   c2.4,0,3.8,1.7,3.8,3.6C18.7,47.4,17.3,49,14.9,49z M14.8,43.1h-3.2v4.6h3.2c1.4,0,2.4-0.9,2.4-2.3C17.2,44,16.2,43.1,14.8,43.1z
    M25.2,53.8h-3c-0.6,0-1.1-0.5-1.1-1.1v-9.8c0-0.6,0.5-1.1,1.1-1.1h3c3.7,0,6.2,2.6,6.2,6C31.4,51.2,29,53.8,25.2,53.8z M25.2,43.1
   h-2.6v9.3h2.6c2.9,0,4.6-2.1,4.6-4.7C29.9,45.2,28.2,43.1,25.2,43.1z M41.5,43.1h-5.8V47h5.7c0.4,0,0.6,0.3,0.6,0.7
   s-0.3,0.6-0.6,0.6h-5.7v4.8c0,0.4-0.3,0.7-0.8,0.7c-0.4,0-0.7-0.3-0.7-0.7V42.9c0-0.6,0.5-1.1,1.1-1.1h6.2c0.4,0,0.6,0.3,0.6,0.7
   C42.2,42.8,41.9,43.1,41.5,43.1z"
        />
      </svg>
    );
  },
  TXT() {
    return (
      <svg
        width="64px"
        height="64px"
        viewBox="-4 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.151-.036c-2.803 0-5.074 2.272-5.074 5.074v53.841c0 2.803 2.271 5.074 5.074 5.074h45.774c2.801 0 5.074-2.271 5.074-5.074v-38.605l-18.902-20.31h-31.946z"
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#F9CA06"
        />
        <g fill-rule="evenodd" clip-rule="evenodd">
          <path
            d="M56.008 20.316v1h-12.799s-6.312-1.26-6.129-6.708c0 0 .208 5.708 6.004 5.708h12.924z"
            fill="#F7BC04"
          />
          <path
            d="M37.106-.036v14.561c0 1.656 1.104 5.792 6.104 5.792h12.799l-18.903-20.353z"
            opacity=".5"
            fill="#fff"
          />
        </g>
        <path
          d="M18.763 43.045h-3.277v10.047c0 .414-.324.738-.756.738-.414 0-.738-.324-.738-.738v-10.047h-3.259c-.36 0-.648-.288-.648-.684 0-.36.288-.648.648-.648h8.03c.36 0 .648.288.648.685 0 .359-.288.647-.648.647zm11.7 10.803c-.216 0-.415-.089-.541-.27l-3.727-4.97-3.745 4.97c-.126.181-.324.27-.54.27-.396 0-.72-.306-.72-.72 0-.144.036-.306.144-.432l3.889-5.131-3.619-4.826c-.09-.126-.144-.27-.144-.414 0-.343.288-.721.72-.721.216 0 .432.108.576.288l3.439 4.627 3.439-4.646c.126-.18.324-.27.541-.27.378 0 .738.306.738.721 0 .144-.036.288-.126.414l-3.619 4.808 3.89 5.149c.09.126.126.27.126.415 0 .396-.325.738-.721.738zm11.195-10.803h-3.277v10.047c0 .414-.323.738-.756.738-.414 0-.738-.324-.738-.738v-10.047h-3.259c-.36 0-.648-.288-.648-.684 0-.36.288-.648.648-.648h8.03c.36 0 .648.288.648.685.001.359-.287.647-.648.647z"
          fill="#fff"
        />
      </svg>
    );
  },
  DOC() {
    return (
      <svg
        width="64px"
        height="64px"
        viewBox="-4 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill-rule="evenodd">
          <path
            d="m5.11 0a5.07 5.07 0 0 0 -5.11 5v53.88a5.07 5.07 0 0 0 5.11 5.12h45.78a5.07 5.07 0 0 0 5.11-5.12v-38.6l-18.94-20.28z"
            fill="#107cad"
          />
          <path
            d="m56 20.35v1h-12.82s-6.31-1.26-6.13-6.71c0 0 .21 5.71 6 5.71z"
            fill="#084968"
          />
          <path
            d="m37.07 0v14.56a5.78 5.78 0 0 0 6.11 5.79h12.82z"
            fill="#90d0fe"
            opacity=".5"
          />
        </g>
        <path
          d="m14.24 53.86h-3a1.08 1.08 0 0 1 -1.08-1.08v-9.85a1.08 1.08 0 0 1 1.08-1.08h3a6 6 0 1 1 0 12zm0-10.67h-2.61v9.34h2.61a4.41 4.41 0 0 0 4.61-4.66 4.38 4.38 0 0 0 -4.61-4.68zm14.42 10.89a5.86 5.86 0 0 1 -6-6.21 6 6 0 1 1 11.92 0 5.87 5.87 0 0 1 -5.92 6.21zm0-11.09c-2.7 0-4.41 2.07-4.41 4.88s1.71 4.88 4.41 4.88 4.41-2.09 4.41-4.88-1.72-4.87-4.41-4.87zm18.45.38a.75.75 0 0 1 .2.52.71.71 0 0 1 -.7.72.64.64 0 0 1 -.51-.24 4.06 4.06 0 0 0 -3-1.38 4.61 4.61 0 0 0 -4.63 4.88 4.63 4.63 0 0 0 4.63 4.88 4 4 0 0 0 3-1.37.7.7 0 0 1 .51-.24.72.72 0 0 1 .7.74.78.78 0 0 1 -.2.51 5.33 5.33 0 0 1 -4 1.69 6.22 6.22 0 0 1 0-12.43 5.26 5.26 0 0 1 4 1.72z"
          fill="#fff"
        />
      </svg>
    );
  },
  Import() {
    return <CloudArrowDown />;
  },
  Report() {
    return <Scroll />;
  },
  DragAndDrop() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="icon icon-tabler icon-tabler-grip-vertical"
        width="48"
        height="48"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0m1 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0m1 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0m7 -14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0m1 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0m1 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
      </svg>
    );
  },
};
export default icons;
